export default __webpack_public_path__ + "static/media/Group 11777.5ab7a3eb.svg";